module.exports = angular.module('email-engagement-form', [
    require('../../../controllers/triggerPanel/webSiteEngagementCtrl').name
])
    .directive('emailEngagementForm', function () {
        return {
            restrict: 'E',
            scope: false,
            templateUrl: 'app/views/triggerPanel/email-engagement-form.tpl.html',
            controller: 'websiteEngagementCtrl'
        };
    });



// WEBPACK FOOTER //
// ./app/directives/canvas_directives/triggerPanel/email-engament-form.js